<template lang="pug">

v-card(v-if="item && show", style="border-radius:10px;background-color:#EAEAEA;box-shadow:none !important;min-height: 100%;").Poppins.LeitorInputs

    #tabs.pa-0.pt-2.md12.xs12(v-bind:class="[$root.mobile ? 'containerMobile' : 'container']")
        .md12.xs12(v-bind:class="[$root.mobile ? 'tabsMobile' : 'tabs']")
            a.md12.xs4(v-on:click="activetab=1", v-bind:class="[ activetab === 1 ? 'active' : '' ]", :style="{'width': !item.modelo_id ? '33%' : '100%'}")
                v-flex.tabDosItens
                    img.mr-2(:src="require('@/assets/images/iconGeral.svg')", v-bind:class="[$root.mobile ? 'mw-15' : 'mw-20.mr-2']")
                    span.font-weight-medium.align-center(v-bind:class="[$root.mobile ? 'body-1' : 'subheading']") Geral

            a.md12.xs4(v-on:click="activetab=2", v-bind:class="[ activetab === 2 ? 'active' : '' ]",  v-show="!item.modelo_id")
                v-flex.tabDosItens
                    img.mr-2(:src="require('@/assets/images/iconComplementos.svg')", v-bind:class="[$root.mobile ? 'mw-15' : 'mw-20.mr-2']")
                    span.font-weight-medium(v-bind:class="[$root.mobile ? 'body-1' : 'subheading']") Variações
            a.md12.xs4(v-on:click="activetab=3", v-bind:class="[ activetab === 3 ? 'active' : '' ]", v-show="!item.modelo_id")
                v-flex.tabDosItens
                    img(:src="require('@/assets/images/iconPromocao.svg')", v-bind:class="[$root.mobile ? 'mw-15' : 'mw-20.mr-2']")
                    span.font-weight-medium(v-bind:class="[$root.mobile ? 'body-1' : 'subheading']") Promoção
        .content
            //- Informações Gerais
            dialogItemVariacao(ref="dialogItemVariacao", @refresh-variacoes="refreshVariacoes", v-if="item && item")
            dialogVariacoes(ref="dialogVariacoes", @refresh-variacoes="refreshVariacoes")
            dialogDesativarItem(ref="dialogDesativarItem", @refresh-itens="refreshListVariacoes")

            div.pb-0(v-if="activetab === 1", class="tabcontent")
                form(@submit.prevent="validate('item')",data-vv-name="item",style="width: 100%",)
                    v-layout(row, wrap, v-if="!item.modelo_id")
                        v-flex.md12.xs12
                            .title(style="color:#111312cc;") {{"Categoria: " + (item.categoria ? item.categoria : categoria.nome)}}
                    v-layout(row, wrap)
                        v-flex.md12.xs12(v-if="isIntegrado(item)", @click="copiar(item.cod_bar)" style="cursor: pointer;")
                            v-text-field.inputDefault(
                                color="gray",
                                label="Código de Barras",
                                height="40px"
                                type="text",
                                v-model="item.cod_bar",
                                outline,
                                :hide-details="true"
                                disabled
                            )
                        v-flex.xs12.md12.sm12.my-2
                            v-layout(row, wrap)
                                v-flex.xs12
                                    v-text-field.inputDefault(
                                        class="bordaInput"
                                        color="gray",
                                        label="Nome",
                                        required,
                                        height="40px"
                                        v-validate="'required'",
                                        data-vv-name="nome",
                                        type="text",
                                        v-model="item.nome",
                                        autofocus,
                                        outline,
                                        :hide-details="true"
                                        :disabled="!(editarCardapio && $root.user.permissao_cardapio) || verifyPromoSpecialItem(item)"
                                    )
                        v-flex.xs12.md6.sm12.my-2.pr-1
                            v-layout(row, wrap)
                                v-flex.xs12.pt-0
                                    v-textarea.inputDefault.inputDescricao(
                                        color="gray",
                                        label="Descrição",
                                        type="text",
                                        v-model="item.descricao",
                                        outline,
                                        :hide-details="true"
                                        :disabled="!(editarCardapio && $root.user.permissao_cardapio) || verifyPromoSpecialItem(item)"
                                    )
                        v-flex.xs12.md6.pt-0.my-2.pl-1
                            v-flex.xs12.md12.text-xs-center.br-10(:class="{'loadingImagem' : loading}", style="border:1px solid rgba(0,0,0,0.2); background-color: #f6f6f6; min-height:268px;aspect-ratio: 1/1;")
                                v-layout(row, wrap, align-center, style="height: 100%;")
                                    v-flex.md12.pa-0(style="height: 100%;")
                                        div.d-flex.justify-center(
                                            v-if="!imagem",
                                            style="position: relative; height: 100%;"
                                        )
                                            crop-image.seletorImagem(
                                                :defaultImage.sync="imagem",
                                                :height="500",
                                                :width="500",
                                                :circle="false",
                                                :disabled="!(editarCardapio && $root.user.permissao_cardapio) || verifyPromoSpecialItem(item)"
                                            )
                                        div(v-else,style="position: relative; aspect-ratio: 1/1;")
                                            img.md6.xs6.posicaoImagem(
                                                :src="imagem.indexOf('data:') > -1 ? imagem : `${urlImagem}/item/${imagem}`",
                                                style="border-radius: 5px;max-width: 100%;max-height: 100%;",
                                            )
                                            v-tooltip.iconDeletar(top, v-if="!item.modelo_id")
                                                v-btn(icon, @click="fakeDelImage(item)",:disabled="verifyPromoSpecialItem(item)"  v-show="!loading && editarCardapio && $root.user.permissao_cardapio", slot="activator")
                                                    v-icon(color="red") delete
                                                span Remover Imagem
                    v-layout(row, wrap)
                        v-flex.xs12
                            v-text-field.inputDefault(
                                color="gray",
                                label="Código PDV",
                                height="40px"
                                type="text",
                                v-model="item.pdv",
                                outline,
                                :hide-details="true"
                                :disabled="!(editarCardapio && $root.user.permissao_cardapio) || verifyPromoSpecialItem(item)"
                            )
                    v-layout(row, wrap, v-if="!item.modelo_id").py-2
                        v-flex.md12.xs12
                            .subheading(style="color:#111312cc;") Disposição do Item
                            div.br-10.areaHorarios
                                span.boxDiaDaSemana(v-for="(dia, index) in diasSemana", :key="index")
                                    v-btn.mx-1(
                                        icon,
                                        small,
                                        :disabled="!(editarCardapio && $root.user.permissao_cardapio) || verifyPromoSpecialItem(item)"
                                        @click="toggleDisponibilidade(item, index)"
                                    )
                                        v-icon(color="primary") {{ item.disponibilidade[index] ? 'check_box' : 'check_box_outline_blank' }}
                                    label.v-label.font-weight-regular.grey--text.text--darken-2 {{ dia }}
                    v-layout(row, wrap).py-2
                        v-flex.xs6.pb-0.pt-0
                            .subheading(style="color:#11131280;")
                            v-currency-field.inputDefault(
                                :label="item.preco_variavel ? 'À partir de:' : 'Preço:'",
                                color="gray",
                                required,
                                v-validate="'required|min_value:0.1'",
                                name="preco",
                                :error-messages="errors.collect('preco')",
                                data-vv-name="preco",
                                data-vv-as="preco",
                                type="text",
                                v-model="item.preco",
                                v-bind="currency_config",
                                :disabled="!!(item.modelo_id || !(editarCardapio && $root.user.permissao_cardapio)) || verifyPromoSpecialItem(item)"
                                :hide-details="true"
                                outline
                            )
                        v-flex.xs6.pt-0
                            v-checkbox.right(
                                style="margin-top:0px !important;"
                                label="Preço Variável?"
                                color="primary",
                                :true-value="1",
                                :false-value="0",
                                v-model="item.preco_variavel",
                                :disabled="!(editarCardapio && $root.user.permissao_cardapio) || verifyPromoSpecialItem(item)",
                                v-if="!item.modelo_id"
                            )
                    v-spacer
                    //- v-flex.md12.xs12.pt-0(v-bind:class="[$root.mobile ? 'areaAbtnsComplementos' : '']")
                    //-     v-card-actions.pa-0.right.mb-5(v-if="(editarCardapio && $root.user.permissao_cardapio)")
                    //-         v-spacer(v-if="!$root.mobile")
                    //-         v-btn.btnSalvar(
                    //-             v-if="$root.mobile"
                    //-             depressed
                    //-             type="submit",
                    //-             :loading="loading",
                    //-             :disabled="loading",
                    //-             ) Salvar

            div(v-if="activetab === 2", :disabled="!item.id", class="tabcontent", v-show="!item.modelo_id")
                v-layout(row, wrap)
                    v-flex.areaAbtnsComplementos.md12.xs12.pa-0
                        v-btn.br-5(
                            slot="activator",
                            height="33px",
                            @click="openDialogVariacoes()",
                            class="botaoHover",
                            depressed
                            width="auto"
                            :disabled="!(editarCardapio && $root.user.permissao_cardapio)  || !item.id",
                        )
                            span.custom-color.Poppins(class="introbotaoHover")
                                img(
                                    :src="require('@/assets/images/iconDocuments.svg')"
                                    style="width:15px;"
                                )
                            | Usar variação existente
                        v-btn.right.btnAdicionarVariacao(
                            color="primary",
                            @click="openDialogCategoriaVariacao()"
                            depressed
                            :disabled="!(editarCardapio && $root.user.permissao_cardapio) || !item.id",
                            width="auto"
                        )
                            | Adicionar variação
                            i.pl-2.fa.fa-plus

                    v-flex.md12.px-2
                      v-text-field.Poppins.icon-green.inputDefault(
                        label="Complemento...",
                        color="primary",
                        v-model="searchTerm",
                        clearable,
                        outline,
                        :hide-details="true",
                        prepend-inner-icon="search"
                      )
                v-layout(row, wrap)
                    v-flex.areaAbtnsComplementos.md12.xs12.pa-0(v-if="!item.id")
                      span.primary--text(style="display: flex; justify-content: center;") Preencha e cadastre o item antes de adicionar uma variação.
                v-card.card--flex-toolbar.mt-3
                    dialogCategoriaVariacao(ref="dialogCategoriaVariacao", @refresh-variacoes="refreshVariacoes")

                v-card.card--flex-toolbar.mt-2.br-10(
                    v-for="categoriaVariacao in filteredVariacoes()",
                    :key="categoriaVariacao.id",
                    style="box-shadow:none;background-color: transparent;"
                    )
                    v-flex.md12.pt-2.pb-2.d-flex(
                        :class="{ 'padraoVariacao': categoriaVariacao.ativo, 'vermelhoVariacao': !categoriaVariacao.ativo }",
                        style="border: 1px solid rgba(17, 19, 18, 0.1);"
                        )
                        v-flex.md10.lg9
                            .areaTexto(style="word-wrap: break-word")
                                .subheading.mt-1 {{ categoriaVariacao.nome }}
                                    v-chip.ml-2(style="height:18px; background-color: #111312 !important;")
                                        div.caption.font-weight-medium(style="color:#fff") {{categoriaVariacao.min > 0 ? 'Obrigatório' : 'Opcional'}}
                                .caption.mt-1 {{ getNomeVariacao(categoriaVariacao) }} (min {{ categoriaVariacao.min }} / max {{ categoriaVariacao.max }})
                                .caption.lb-danger--text.mt-1(
                                    v-if="categoriaVariacao.ativo && categoriaVariacao.itens_vinculados_excludente && categoriaVariacao.itens_vinculados_excludente.length"
                                ) Complemento utilizado em outros {{ categoriaVariacao.itens_vinculados_excludente.length }} itens
                                .caption.lb-danger--text.mt-1(
                                    v-if="!categoriaVariacao.ativo"
                                ) CATEGORIA INDISPONÍVEL
                        v-spacer
                        v-flex.d-flex.md2.lg3(style="display:flex;align-items: center; flex-wrap: wrap;align-items: center;align-content: center;justify-content: center;")
                            v-btn(flat, icon, color="primary", :disabled="!(editarCardapio && $root.user.permissao_cardapio)",
                                    @click="openDialogItemVariacao(null, categoriaVariacao)")
                                i.pa-1.fa.fa-plus.iconAdicionarVariacao(
                                )
                            v-menu.md3(offset-y,style="width: 100%;")
                                template(v-slot:activator="{ on, attrs }")
                                    v-btn(flat, icon, v-bind="attrs", v-on="on", color="primary")
                                        i.fa.fa-ellipsis-v
                                v-list.Poppins.listaDeOpcoes
                                    v-list-tile
                                        v-btn.Poppins.Capitalize.ma-0.pl-0.pr-0(flat, @click="openDialogCategoriaVariacao(categoriaVariacao)",:disabled="!(editarCardapio && $root.user.permissao_cardapio)",)
                                            | Editar
                                    v-list-tile
                                        v-btn.Poppins.Capitalize.ma-0.pl-0.pr-0(flat, @click="excluirVariacao(categoriaVariacao)",:disabled="!(editarCardapio && $root.user.permissao_cardapio)",)
                                            | Excluir
                    div(v-for="itemVariacao in getFilteredItensForCategoria(categoriaVariacao)", :key="itemVariacao.id")
                        v-card-text(:class="{ 'red lighten-4': !isAtivo(itemVariacao) }")
                            v-layout(row, wrap, align-center)
                                v-flex.xs2(v-if="!$root.mobile")
                                  img.rounded-10(
                                    style="max-width:60px;"
                                    :src="itemVariacao.imagem ? `${urlImagem}/item/${itemVariacao.imagem}` : require('@/assets/images/invalidImage.svg')",
                                    aspect-ratio="1/1",
                                    cover="true"
                                  )
                                v-flex.xs6.sm6.pl-4(style="word-wrap: break-word")
                                    .subheading {{ itemVariacao.nome }}
                                    .caption.lb-danger--text(
                                        v-if="!itemVariacao.disponivel && itemVariacao.data_disponivel"
                                    ) INDISPONÍVEL ATÉ DIA {{ $dayjs(itemVariacao.data_disponivel).format('DD/MM/YYYY') }}
                                    .caption(style="color: #000000c1;") {{ itemVariacao.descricao }}
                                v-flex(v-if="itemVariacao.mod_preco != 6").xs2.text-xs-center
                                    .body-2 {{ itemVariacao.preco | currency }}
                                v-flex(v-if="itemVariacao.mod_preco == 6").xs2.text-xs-center
                                    .body-2 {{ Math.round(itemVariacao.preco * 100) }}%
                                v-flex.xs2.text-xs-right.pr-4(style="z-index: 9999;")
                                    v-menu(offset-y)
                                        template(v-slot:activator="{ on, attrs }")
                                            v-btn(flat, icon, v-bind="attrs", v-on="on", color="primary")
                                                i.fa.fa-ellipsis-v
                                        v-list.Poppins.listaDeOpcoes(style="z-index: 999;")
                                            v-list-tile
                                                v-btn.Poppins.Capitalize.ma-0.pl-0.pr-0(flat, :disabled="loading || !(editarCardapio && $root.user.permissao_cardapio)", @click="openDialogItemVariacao(itemVariacao, categoriaVariacao)")
                                                    | Editar
                                            v-list-tile
                                                v-btn.Poppins.Capitalize.ma-0.pl-0.pr-0(flat, :disabled="loading || !(editarCardapio && $root.user.permissao_cardapio)", @click="isAtivo(itemVariacao) ? openDialogDesativarItem(itemVariacao) : ativarItemVariacao(itemVariacao)")
                                                    | {{ isAtivo(itemVariacao) ? 'Desativar' : 'Ativar ' }}
                        v-divider

            div(v-if="activetab === 3", :disabled="!item.id", class="tabcontent", v-show="!item.modelo_id")
                form(@submit.prevent="validate('item3')", data-vv-name="item3",style="width: 100%")
                    v-layout(row, wrap)
                        v-flex.md4.xs12.pa-0
                            v-currency-field.inputDefault(
                                label="Preço Original",
                                color="primary",
                                required,
                                v-validate="'required|min_value:0.1'",
                                name="preco",
                                :error-messages="errors.collect('preco')",
                                data-vv-name="preco",
                                data-vv-as="preco",
                                type="text",
                                v-model="item.preco",
                                v-bind="currency_config",
                                :hide-details="true",
                                outline,
                                :disabled="!(editarCardapio && $root.user.permissao_cardapio) || verifyPromoSpecialItem(item)",
                            )
                        v-flex.md8.xs12
                            v-checkbox.right(
                                label="Item Promocional",
                                v-model="item.promocional",
                                :true-value="1",
                                :false-value="0",
                                color="primary",
                                :disabled="!(editarCardapio && $root.user.permissao_cardapio) || verifyPromoSpecialItem(item)",
                            )
                    v-layout(row, wrap)
                        v-flex.md4.xs12.pa-0
                            v-currency-field.inputDefault(
                                label="Preço Promocional",
                                color="primary",
                                required,
                                v-validate="`required|max_value:${item.preco - 0.01}|min_value:0.1`",
                                name="preco_promocional",
                                :error-messages="errors.collect('preco_promocional')",
                                data-vv-name="preco_promocional",
                                data-vv-as="preco promocional",
                                v-model="item.preco_promocional",
                                v-bind="currency_config",
                                :disabled="!item.promocional || !item.preco || !(editarCardapio && $root.user.permissao_cardapio) || verifyPromoSpecialItem(item)",
                                :hide-details="true",
                                outline
                            )
                    v-layout.mt-4(row, wrap)
                        v-flex.md12.xs12
                          .subheading A promoção tem vigência definida?
                        v-flex.md12.xs12
                          v-radio-group.mt-0.pt-0(v-model="vigenciaPromoItem", row :disabled="!(editarCardapio && $root.user.permissao_cardapio)",)
                              v-radio(:value="true", label="Sim", color="primary")
                              v-radio(:value="false", label="Não", color="primary")
                    v-layout(row, wrap, v-if="vigenciaPromoItem")
                        v-flex.md12.xs12.pt-0
                          .subheading Preencha os campos Data Inicial e Data Final caso a promoção tenha vigência definida
                    v-layout(row, wrap, v-if="vigenciaPromoItem")
                        v-flex.md6.xs12.pl-0.pb-0.pr-1
                            v-text-field.inputDefault(
                                type="datetime-local",
                                color="primary",
                                label="Data Inicial",
                                :disabled="!item.promocional || !item.preco_promocional || !(editarCardapio && $root.user.permissao_cardapio) || verifyPromoSpecialItem(item)",
                                v-model="item.data_inicio",
                                v-validate="'required'",
                                :error-messages="errors.collect('data_inicio')",
                                data-vv-name="data_inicio",
                                data-vv-as="data inicial",
                                required,
                                :hide-details="true",
                                outline
                            )
                        v-flex.md6.xs12.pl-1.pb-0.pr-0
                            v-text-field.inputDefault(
                                type="datetime-local",
                                color="primary",
                                label="Data Final",
                                :disabled="!item.promocional || !item.preco_promocional || !(editarCardapio && $root.user.permissao_cardapio) || verifyPromoSpecialItem(item)",
                                v-model="item.data_fim",
                                v-validate="'required'",
                                :error-messages="errors.collect('data_fim')",
                                data-vv-name="data_fim",
                                data-vv-as="data final",
                                required,
                                :hide-details="true",
                                outline
                            )
                    v-layout(
                        row,
                        wrap,
                        v-if="item.promocional && item.data_inicio && item.data_fim && vigenciaPromoItem"
                    )
                        v-flex.md6.xs12
                        .subheading Manter o item com preco original no cardápio após o término da promoção?
                    v-layout(
                        row,
                        wrap,
                        v-if="item.promocional && item.data_inicio && item.data_fim && vigenciaPromoItem"
                    )
                        v-flex.md6.xs12
                            v-radio-group(v-model="defaultValue", row, @change="handlerPromotion(defaultValue);" :disabled="!(editarCardapio && $root.user.permissao_cardapio)",)
                                v-radio(:value="1", label="Sim", color="primary")
                                v-radio(:value="0", label="Não", color="primary")

                    //- v-flex.md12.xs12.pt-0(v-bind:class="[$root.mobile ? 'areaAbtnsComplementos' : '']")
                    //-     v-card-actions.pa-0.right.mb-5(v-if="(editarCardapio && $root.user.permissao_cardapio)")
                    //-         v-spacer(v-if="!$root.mobile")
                    //-         v-btn.mt-2.btnSalvar(
                    //-             v-if="$root.mobile"
                    //-             depressed
                    //-             type="submit",
                    //-             :loading="loading",
                    //-             :disabled="loading",
                    //-             ) Salvar
</template>
<script>

import CropImage from "@/components/CropImage";

import dialogCategoriaVariacao from '@/pages/cardapio/dialog/CategoriaVariacao';
import dialogItemVariacao from '@/pages/cardapio/dialog/ItemVariacao';
import dialogVariacoes from '@/pages/cardapio/dialog/Variacoes';
import dialogDesativarItem from '@/pages/cardapio/dialog/DesativarItem';


export default {
    $_veeValidate: {
        validator: "new",
    },
    components: {
        CropImage,
        dialogCategoriaVariacao,
        dialogItemVariacao,
        dialogVariacoes,
        dialogDesativarItem
    },
    data: () => ({
        show: false,
        editarCardapio: false,
        loading: false,
        item: null,
        imagem: null,
        categoria: null,
        diasSemana: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
        tab: 0,
        currency_config: {
            decimal: ",",
            thousands: ".",
            prefix: "R$ ",
            suffix: "",
            precision: 2,
            masked: false,
            min: 0,
        },
        defaultValue: 1,
        horariosDiposiveis: [],
        activetab: 1,
        delAfterSave: false,
        imagemToDelete: null,
        vigenciaPromoItem: false,
        searchTerm: ''
    }),
    mounted() { },
    computed: {
      urlImagem(){
        return process.env.VUE_APP_IMAGE_URL;
      }
    },
      methods: {
        delAfterSaveFunc(bool){
          this.delAfterSave = bool;
        },
        handlerPromotion(defaultValue) {
          this.item.fixo = defaultValue;
        },
        toggleDisponibilidade(item, index) {
          this.item.disponibilidade[index] = !item.disponibilidade[index];
          this.$forceUpdate();
        },
        indiceNovoItem() {
            if (!this.categoria) {
                return 0;
            }

            if (this.categoria.total_itens != null) {
                return parseInt(this.categoria.total_itens);
            }

            return this.categoria.allItens ? parseInt(this.categoria.allItens.length) : 0;
        },
        open(item, categoria, categorias, catalogo) {
            this.show = true;
            this.categoria = categoria;
            this.categorias = categorias;
            this.tab = 0;
            this.item = item
                ? _.cloneDeep(item)
                : {
                    categoria_id: this.categoria.id,
                    disponibilidade_diaria: "0,1,2,3,4,5,6",
                    preco: 0,
                    promocional: 0,
                    preco_promocional: 0,
                    preco_variavao: 0,
                    indice: this.indiceNovoItem(),
                    variacoes: [],
                    ativo: 1,
                    disponivel: 1,
                    arquivado: 0,
                    data_inicio: null,
                    data_fim: null,
                    catalogo_id: catalogo.id,
                    versao: 0,
                    mod_preco: this.categoria.mod_preco,
                    min: this.categoria.min,
                    max: this.categoria.max,
                };
            this.formatToOpen(this.item);
        },
        isEditor(valor){
            this.editarCardapio = valor;
        },
        ocultarItem(){
            this.show = false;
        },
        resetMenu(){
            this.activetab = 1;
        },
        isIntegrado(item) {
            return item.cod_bar && item.modelo_id;
        },
        copiar(texto) {
            const textarea = document.createElement('textarea');
            textarea.value = texto;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            window.getApp.$emit("APP_ALERT", {
                color: "success",
                text: "Código copiado com sucesso!",
            });
        },
        async openDialogVariacoes() {
            if(this.verifyPromoSpecialItem(this.item))
                return this.showMsgPromoSpecial();
            var categoriasVariacao = await this.getVariacoes();
            this.$refs.dialogVariacoes.open(categoriasVariacao, this.item);
        },
        openDialogCategoriaVariacao(categoriaVariacao) {
            if(this.verifyPromoSpecialItem(this.item))
                return this.showMsgPromoSpecial();

            this.$refs.dialogCategoriaVariacao.open(categoriaVariacao, this.item);
        },
        openDialogItemVariacao(itemVaricao, categoriaVariacao) {
            if(this.verifyPromoSpecialItem(this.item))
                return this.showMsgPromoSpecial();

            this.$refs.dialogItemVariacao.open(itemVaricao, categoriaVariacao);
        },
        orderedVariacoes() {
            return _.orderBy(this.item.variacoes || [], 'indice')
        },
        filteredVariacoes() {
          if (!this.searchTerm || this.searchTerm.trim() == '') {
            return _.orderBy(this.item.variacoes || [], 'indice')
          }

          return this.orderedVariacoes().filter(categoriaVariacao => {
            return categoriaVariacao.allItens && categoriaVariacao.allItens.some(item =>
              item.nome.toLowerCase().includes(this.searchTerm.toLowerCase())
            );
          });
        },
        getFilteredItensForCategoria(categoriaVariacao) {
          if (!this.searchTerm || this.searchTerm.trim() == '') {
            return categoriaVariacao.allItens || [];
          }

          return (categoriaVariacao.allItens || []).filter(item =>
            item.nome.toLowerCase().includes(this.searchTerm.toLowerCase())
          );
        },
        openDialogDesativarItem(item) {
            this.$refs.dialogDesativarItem.open(item);
        },
        refreshListVariacoes(item) {
            this.$forceUpdate();
        },
        refreshVariacoes(categoria) {
            this.item.variacoes = this.item.variacoes || [];
            var categoriaVariacao = _.find(this.item.variacoes, { variacao_id: categoria.variacao_id })
            if (!categoriaVariacao)
                this.item.variacoes.push(categoria);
            else {
                categoriaVariacao = _.merge(categoriaVariacao, categoria);
            }
            this.$forceUpdate();
        },
        isAtivo(item) {
            return item.ativo && item.disponivel;
        },
        getNomeVariacao(variacao) {
            var mod = _.find(this.mod_preco, { id: variacao.mod_preco });
            return mod ? mod.nome : null;
        },
        verifyPromoSpecialItem(item) {
            return item.especial && item.promocional ? true : false;
        },
        showMsgPromoSpecial() {
            return window.getApp.$emit("APP_ALERT", {
                color: "orange",
                text: "Não é possível executar a ação pois este item está participando de uma promoção especial!",
            });
        },
        formatToSend(item) {
            let disponibilidadeDiaria = [];
            _.forEach(
                item.disponibilidade,
                (o, i) => {
                    if (o)
                        disponibilidadeDiaria.push(i);
                }
            )

            item.disponibilidade_diaria = disponibilidadeDiaria.toString();

            if (!item.promocional){
                item.preco_promocional = "NULL";
                item.data_inicio = "NULL";
                item.data_fim = "NULL";
            } else{
                item.data_inicio = !item.data_inicio ? null  : item.data_inicio == "NULL" ?  "NULL" : this.$dayjs(item.data_inicio, "YYYY-MM-DDThh:mm").format("YYYY-MM-DD HH:mm:ss");
                item.data_fim = !item.data_fim ? null : item.data_fim == "NULL" ?  "NULL" :  this.$dayjs(item.data_fim, "YYYY-MM-DDThh:mm").format("YYYY-MM-DD HH:mm:ss");
            }

            return item;
        },
        async formatToOpen(item) {

            if (!item.variacoes) item.variacoes = [];
            item.data_inicio = item.data_inicio
                ? this
                    .$dayjs(
                        item.data_inicio,
                        "YYYY-MM-DD HH:mm:ss"
                    )
                    .format("YYYY-MM-DDTHH:mm")
                : null;
            item.data_fim = item.data_fim
                ? this
                    .$dayjs(
                        item.data_fim,
                        "YYYY-MM-DD HH:mm:ss"
                    )
                    .format("YYYY-MM-DDTHH:mm")
                : null;
            this.imagem = item.imagem;

            item.disponibilidade = _.map(
                [0, 1, 2, 3, 4, 5, 6],
                (o) =>
                    item.disponibilidade_diaria.indexOf(o) > -1
            );
            if(item.data_inicio || item.data_fim){
              this.vigenciaPromoItem = true;
            } else {
              this.vigenciaPromoItem = false;
            }

            item.variacoes = item.id ? await this.getVariacoesItem(item) : [];

            this.$forceUpdate();
        },
        fakeDelImage(item){
          this.imagemToDelete = this.imagem;
          item.imagem = null;
          this.imagem = null;
          this.delAfterSave = true;
        },
        async validate(scope) {
            try {
                const result = await this.$validator.validateAll(scope);
                if (!result) throw "Preencha todos os campos corretamente!";

                if (this.item && !this.item.nome)
                    throw "O item deve ter um nome!";
                if (this.item && this.item.nome && this.item.nome.length > 100)
                    throw "O nome do item deve ter menos de 100 caracteres!";
                if (this.item && !this.item.preco)
                    throw "O valor do item não pode estar zerado!";
                else if (this.item && !!this.item.promocional && !this.item.preco_promocional)
                    throw "O valor da promoção não pode estar zerado!";
                else if (
                    this.item &&
                    !!this.item.promocional &&
                    this.item.preco_promocional > this.item.preco
                )
                    throw "O valor da promoção não pode ser maior que o valor do item!";
                else if (this.item && this.item.preco > 999)
                    throw "O preço do item não pode ser maior que R$999,00! Caso seja necessário consulte o suporte!";
                else if (this.item && this.item.preco < 0)
                    throw "O preço do item não pode ser negativo!";
                else if (this.item && !!this.item.promocional && this.item.preco_promocional == 0)
                    throw "Não é possível salvar uma promoção com preço igual a 0.";
                else if (this.item && !!this.item.promocional && this.item.preco_promocional < 0)
                    throw "Não é possível salvar uma promoção com preço menor que 0.";
                else if (this.item && !!this.item.promocional && this.item.preco_promocional && this.item.preco && this.item.preco_promocional == this.item.preco)
                    throw "Não é possível salvar uma promoção com preço igual ao preço original.";

                await this.save(this.item);
                return true;
            } catch (error) {
                window.getApp.$emit("APP_ALERT", { color: "red", text: error });
                this.loading = false;
            }
        },
        async save(item) {
            if (item && this.verifyPromoSpecialItem(item))
                return this.showMsgPromoSpecial();
            try {

                if (this.imagem && this.imagem.indexOf("data:") > -1) {
                    const filename = await this.uploadImagem(this.imagem);
                    item.imagem = filename;
                    this.imagem = filename;
                } else if (this.delAfterSave) {
                   await this.removeFile();
                }
                this.delAfterSave = false;

                if(!this.vigenciaPromoItem){
                    item.data_inicio = "NULL";
                    item.data_fim = "NULL";
                }

                const response = await this.$axios[item.id ? 'put' : 'post']("/catalogo/item", this.formatToSend(item));
                this.categorias.map((categoria) => {
                    categoria.allItens = categoria.allItens || [];
                    if (categoria.id == item.categoria_id)
                        if (item.id)
                            categoria.allItens.map((item) => {
                                if (item.id == response.data.id)
                                    item = _.merge(item, response.data);
                            });
                        else {
                            item.id = response.data.id;
                            categoria.allItens.push(item);
                            categoria.total_itens = (categoria.total_itens || 0) + 1;
                        }
                });

                this.$forceUpdate();
                this.$validator.reset();
                this.loading = false;

                window.getApp.$emit("APP_ALERT", {
                    color: "success",
                    text: "Item salvo com sucesso!",
                });

            } catch (error) {
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao salvar o item. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
                this.loading = false;
            }
        },
        async removeFile() {
            if (this.imagem && this.imagem.indexOf("data:") > -1) {
                this.imagem = null;
            } else if (this.imagemToDelete) {
                await this.deleteImagem(this.imagemToDelete);
                this.imagemToDelete = null;
            }
        },
        async uploadImagem(imagem) {
            try {
                this.loading = true;
                if(this.delAfterSave) {
                  await this.removeFile();
                }
                const blob = this.$root.b64toBlob(imagem);
                const formData = new FormData();
                formData.append("file", blob, "imagem.jpg");
                const response = await this.$axios.post(
                    "/catalogo/item/imagem",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                            folder: "item",
                            filemethod: "crop",
                        },
                    }
                );
                this.loading = false;
                this.$emit('change-travaclose', false);
                return response.data.file.filename;
            } catch (error) {
                this.loading = false;
                window.getApp.$emit("APP_ALERT", {
                    color: "red",
                    text: "Ocorreu um erro ao salvar a imagem. Tente novamente!",
                });
            }
        },
        async deleteImagem(imagem) {
            try {
                this.loading = true;
                const response = await this.$axios.delete("/catalogo/item/imagem", {
                    params: { id: this.item.id, imagem },
                });
                this.imagem = null;
                this.item.imagem = null;
                this.loading = false;
                this.$emit('change-travaclose', false);
            } catch (error) {

                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao remover a imagem. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
                this.loading = false;
            }
        },
        async excluirVariacao(variacao) {
            try {
                this.$emit('change-travaclose', true);
                const res = await this.$confirm(
                    "<h3>Deseja realmente excluir?</h3><br> Caso queira reverter essa ação, será necessário buscar a Variação em “Usar Variação Existente“"
                );
                if (!res) {
                  this.$emit('change-travaclose', false);
                  return;
                }
                this.loading = true;
                const response = await this.$axios.delete("/catalogo/variacao", {
                    params: {
                        id: variacao.variacao_id,
                    },
                });
                this.item.variacoes = _.reject(this.item.variacoes, {
                  variacao_id: variacao.variacao_id,
                });
                this.$emit('change-travaclose', false);
                this.loading = false;
                window.getApp.$emit("APP_ALERT", {
                    color: "success",
                    text: "Categoria de complemento excluída com sucesso!",
                });
            } catch (error) {
                this.$emit('change-travaclose', false);
                this.loading = false;
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao excluir a categoria de complemento. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
            }
        },
        async ativarItemVariacao(item) {
            const backupItem = _.cloneDeep(item);
            try {
                item.ativo = 1;
                item.disponivel = 1;
                item.data_disponivel = "NULL";

                const response = await this.$axios.put("/catalogo/item", item);

                this.$forceUpdate();
                window.getApp.$emit("APP_ALERT", {
                    color: "success",
                    text: "Item ativado com sucesso!",
                });
                this.$emit('refresh-itens', item);
            } catch (error) {
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao ativar o item. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
                item.ativo = backupItem.ativo;
                item.disponivel = backupItem.disponivel;
                item.data_disponivel = backupItem.data_disponivel;
            }
            this.$forceUpdate();
            this.orderedVariacoes();
        },
        async getVariacoesItem(item) {
            try {
                const response = await this.$axios.get("/catalogo/categoria", {
                    params: {
                        variacao: 1,
                        item_catalogo_id: item.id,
                        fields: "allItens",
                    },
                });

                return await this.getItensVinculados(item, response.data);
            } catch (error) {
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao carregar as categorias. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
            }
        },
        async getItensVinculados(item, categorias) {
            try {
                const promises = await categorias.map(async (categoria) => {
                    const response = await this.$axios.get("/catalogo/variacao", {
                        params: {
                            categoria_id: categoria.id,
                            item_catalogo: true,
                        },
                    });
                    var vinculados = _.filter(response.data, function(_item) {
                        return _item.categoria_arquivado == 0;
                    });

                    categoria.itens_vinculados = vinculados;

                    var vinculadosExcludente = _.filter(vinculados, function(_item) {
                        return _item.item_catalogo_id != item.id
                    });

                    categoria.itens_vinculados_excludente = vinculadosExcludente;
                });
                await Promise.all(promises);
                return categorias;
            } catch (error) {
                throw new Error(error);
            }
        },
        async getVariacoes() {
            try {
                const response = await this.$axios.get("/catalogo/categoria", {
                    params: {
                        fields: "allItens",
                        arquivado: 0,
                        variacao: 1,
                        catalogo_id: this.item.catalogo_id
                    },
                });
                const categoriasVariacao = response.data
                const variacoes = await this.getItensVinculados(this.item, categoriasVariacao);
                return _.filter(variacoes, (variacao) => {
                    return _.find(this.item.variacoes, {
                        categoria_id: variacao.categoria_id,
                    })
                        ? false
                        : true;
                });
            } catch (error) {
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao buscar as categorias de complementos. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });
            }
        },
        async arquivarItemVariacao(itemVariacao) {

            const backupItem = _.cloneDeep(itemVariacao);
            itemVariacao.ativo = 0;
            itemVariacao.data_disponivel = null;
            itemVariacao.arquivado = 1;
            this.loading = true;
            try {
                const possoDeletar = await this.$confirm("<b>Essa ação irá afetar os outros itens que possuem essa categoria de variação.</b><br>Deseja realmente deletar?", { title: "Atenção" });
                    if (!possoDeletar) {
                        itemVariacao.ativo = backupItem.ativo;
                        itemVariacao.disponivel = backupItem.disponivel;
                        itemVariacao.data_disponivel = backupItem.data_disponivel;
                        itemVariacao.arquivado = backupItem.arquivado;

                        this.loading = false;
                    return
                };
                const response = await this.$axios.put("/catalogo/item", itemVariacao);

                const responsedois = await this.$axios.get("/catalogo/categoria", {
                    params: {
                        variacao: 1,
                        item_catalogo_id: this.item.id,
                        fields: "allItens",
                    },
                });
                this.item.variacoes[0].allItens = responsedois.data[0].allItens;
                window.getApp.$emit("APP_ALERT", {
                    color: "success",
                    text: "Item deletado com sucesso!",
                });
                this.$emit('refresh-itens', this.itens);


            }catch (error) {
                let err =
                    error.response && error.response.data
                        ? error.response.data.error
                        : "Ocorreu um erro ao deletar o item. Tente novamente!";
                window.getApp.$emit("APP_ALERT", { color: "red", text: err });

                itemVariacao.ativo = backupItem.ativo;
                itemVariacao.disponivel = backupItem.disponivel;
                itemVariacao.data_disponivel = backupItem.data_disponivel;
                itemVariacao.arquivado = backupItem.arquivado;
            }
            this.loading = false;
            this.$forceUpdate();
        }
    },
};
</script>
<style lang="scss">
.inputDefault .v-input__control .v-input__slot{
    background-color: #f6f6f6!important;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, .15)!important;
}

.inputDefault.v-input.v-input--is-focused .v-input__control .v-input__slot{
    border: 1px solid #1d9a5a !important;
}

.inputDescricao .v-input__control .v-input__slot{
    aspect-ratio: 1/1;

}
</style>
<style scoped>
.promocional {
    text-decoration: line-through !important;
}
.Capitalize {
    text-transform: capitalize;
}
.container {
    color: #888;
}
.containerMobile {
    background-color: #f9f9f9;
}
.tabs {
    overflow: hidden;
    margin: 0 20px;
    display: flex;
    max-height: 55px;
    justify-content: space-around;
    flex-direction: row;
    align-items: stretch;
}
.tabsMobile {
    background-color: #EAEAEA;
    overflow: hidden;
    margin: 3px 20px 10px 20px;
    display: flex;
    max-height: 55px;
    justify-content: space-around;
    flex-direction: row;
    align-items: stretch;
    border-radius: 10px;
}
.tabs ul {
    list-style-type: none;
    margin-left: 20px;
}
.tabsMobile ul {
    list-style-type: none;
    margin-left: 20px;
}

.tabs a{
    float: left;
    width: 33%;
    cursor: pointer;
    padding: 10px 20px;
    transition: background-color 0.2s;
    background-color: #EAEAEA;
    border-radius: 10px 10px 0 0;
    font-weight: bold;
    display: flex;
    color: rgba(17, 19, 18, 0.8);
}
.tabsMobile a{
    float: left;
    font-size: 8px !important;
    cursor: pointer;
    justify-content: center;
    padding: 2px 4px;
    margin: 6px 3px;
    transition: background-color 0.2s;
    border-radius: 10px;
    font-weight: bold;
    display: flex;
    color: rgba(17, 19, 18, 0.8);
}
.tabs a div{
    justify-content: center;
    display: flex;
    align-items: center;
}
.tabsMobile a div{
    justify-content: center;
    display: flex;
    align-items: center;
}
/* Change background color of tabs on hover */
.tabs a:hover {
    background-color: #e3e3e3;
}

/* Styling for active tab */
.tabs a.active {
    background-color: #fafafa;
    color: #484848;
    cursor: default;
}
.tabsMobile a.active {
    background-color: #D9D9D9;
    color: #484848;
    cursor: default;
}

.tabcontent {
    padding: 30px;
    background-color: #fafafa;
    padding-bottom: 120px !important;
}

.btnAdicionarVariacao {
    border-radius: 6px;
    color: #fff;
    min-height: 35px;
    font-size: 17px;
    text-transform: capitalize;
    float: left;
}
.botaoHover {
    color: #111312cc;
    background-color: #eaeaea !important;
    text-transform: capitalize;
}
.botaoEdicao {
    color: #111312cc;
    text-transform: capitalize;
}
.introbotaoHover {
    color: #111312cc;
    background-color: #c7c7c7 !important;
    text-transform: capitalize;
}
.botaoHover:hover {
    background-color: #e3f0e9 !important ;
}
.botaoHover:hover .introbotaoHover {
    background-color: #1d9a594d !important;
}
.botaoHover:hover .introbotaoHover img {
    color: #fff !important;
}
.custom-color {
    display: flex;
    width: 18px;
    height: 18px;
    margin-right: 5px;
    border-radius: 5px;
    justify-content: center;
}
.padraoVariacao {
    background-color: #EFEFEF;
    border: 1px solid rgba(17, 19, 18, 0.08);
    padding: 12px;
}
.vermelhoVariacao {
    background-color: #ffb0b0;
    border-radius: 10px 10px 0px 0px !important;
    border-top: 1px solid #da8e8e !important;
    border-left: 1px solid #da8e8e !important;
    border-right: 1px solid #da8e8e !important;
    padding: 12px;
}
.btnAddComplemento {
    max-height: 15px !important;
    border-radius: 5px;
}
.btnAddComplemento:hover {
    background-color: #1d9a5a;
    color: #fff !important;
}
.tabDosItens{
    flex-wrap: wrap;
    flex-direction: row;
    align-content: center;
    justify-content: center;
    align-items: center;
}
.mw-20{
    max-width: 20px !important;
}
.mw-15{
    max-width: 15px !important;
}
.br-5{
    border-radius: 5px !important;
}
.br-10{
    border-radius: 10px !important;
}
.listaDeOpcoes{
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    font-size: 15px;
    z-index: 9999!important;
}
.boxDiaDaSemana{
    justify-content: center;
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    align-items: center;
    flex-direction: row;
}
.areaHorarios{
    border:1px solid rgba(0,0,0,0.2);
    border-radius:10px;
    display:flex;
    justify-content: space-around;
}
.seletorImagem{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.posicaoImagem{
    width: 100%;
    height: 100%;
    border-radius: 10px;
    object-position: center center;
    object-fit: cover;
}
.iconDeletar{
    position: absolute;
    top: 20px;
    left: 95%;
    transform: translate(-50%, -50%);
    z-index:15;
}
.areaAbtnsComplementos{
    padding: 0 !important;
    justify-content: flex-start;
    display: flex;
    flex-flow:column wrap;
    align-content: stretch;
    align-items: stretch;
}

.btnSalvar{
    width: 100%;
    border-radius: 5px !important;
    color:#fff;
    font-weight: 600;
}

.loadingImagem{
  background: repeating-linear-gradient(45deg,#edfcf3,#edfcf3 5%,#d3f8df 5%,#d3f8df 10%);
  background-size: 100px 100px;
  animation: listras 6s linear infinite;
}
@keyframes listras {
  0% {
    background-position: initial;
  }
  100% {
    background-position: 100px 0px;
  }
}

</style>
